export const cepEventMask = [/\d/, /\d/, /\d/, /\d/, /\d/,  '-', /\d/, /\d/, /\d/]
export const tokenMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
export const codEventMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
export const codFoodMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
export const CPFMask = [/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/]
export const CNPJMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
export const phoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
export const CEPMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]